<template>
  <m-card315 :image="category.image">
    <template #p-1>
      <button class="btn btn-primary rounded-pill" v-t="`category.card.more`"></button>
    </template>
    <template #p-2>
      <h5 class="text-center">{{ category.name }}</h5>
    </template>
  </m-card315>
</template>

<script>
import {CategoryCardProps} from "./CategoryCardProps";
import {CategoryCardComputed} from "./CategoryCardComputed";
import mCard315 from "../../Cards/Card315";
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";

export default {
  name: "CategoryCard315",
  methods: {contentSlicer},
  components: {mCard315},
  props: {
    ...CategoryCardProps,
  },
  computed: {
    ...CategoryCardComputed
  }
}
</script>

<style scoped>
</style>